import { Component, inject } from "@angular/core";
import { FormControl, Validators } from "@angular/forms";
import { compare } from "fast-json-patch";
import { NEVER } from "rxjs";
import { catchError, finalize } from "rxjs/operators";
import { FormControlBase } from "src/app/common-components/form-controls/form-control-base";
import { CstResponsivePopupComponentBase } from "src/app/common-components/resp-popup";
import {
  InfoportalFoldersClientProvider,
  ContractFolderLookupDto,
  ValidationResult,
} from "src/app/web-api/web-api";
import {
  CstFormBuilder,
  CstFormGroup,
} from "src/app/_uncategorised_models_services/cst-form-group";

interface IContractFolderUpdateCommand {
  label: string;
  description: string;
  tagIDs: number[];
}

export interface IInfoportalApiContractFolderUpdateDialogData {
  id: string;
}

@Component({
  templateUrl: "./contract-folder-update-dialog.component.html",
  styleUrls: ["./contract-folder-update-dialog.component.scss"],
  standalone: false,
  host: { "data-dialog-unique": "contract-folder-update-dialog" }, // fixes https://v21.angular.dev/errors/NG0912
})
export class InfoportalApiContractFolderUpdateDialogComponent extends CstResponsivePopupComponentBase<
  IInfoportalApiContractFolderUpdateDialogData,
  ContractFolderLookupDto
> {
  private _client = inject(InfoportalFoldersClientProvider);

  private _origonalValue: IContractFolderUpdateCommand;

  public form: CstFormGroup<IContractFolderUpdateCommand>;
  public loading = false;

  constructor() {
    const fb = inject(CstFormBuilder);

    super();

    this.form = fb.group<IContractFolderUpdateCommand>({
      label: new FormControl(null, [
        Validators.required,
        Validators.maxLength(75),
      ]),
      description: new FormControl(null, Validators.maxLength(2000)),
      tagIDs: new FormControl([]),
    });
  }

  onInitialised() {
    this._client.contractFolderGet(this.data.id).subscribe((result) => {
      this.form.patchValue({ ...result, tagIDs: result.tags.map((x) => x.id) });
      this._origonalValue = { ...this.form.value };
    });
  }

  public canAccept() {
    return this.data.id && this.form.valid;
  }
  public onAccept() {
    if (!this.canAccept()) {
      return;
    }
    this.loading = true;
    const patch = compare(this._origonalValue, this.form.value);
    if (patch.length === 0) {
      this.close();
    }
    this._client
      .contractFolderPatch(this.data.id, patch as any)
      .pipe(
        finalize(() => (this.loading = false)),
        catchError((error) => {
          if (error instanceof ValidationResult) {
            FormControlBase.ApplyValidationResultToForm(this.form, error);
            return NEVER;
          }
          console.error(error);
          return NEVER;
        }),
      )
      .subscribe((result) => this.close(result));
  }

  public onCancel() {
    this.close();
  }
}
